module.exports = __webpack_public_path__ + "static/media/logo-vilanovamartirios.db878438.png";